import React from "react";
import { useMediaQuery } from "react-responsive";
import MobileView from "../src/components/layout/MobileView.jsx";
import HomePage from "../src/components/pages/HomePage.jsx";
import { Routes, Route } from "react-router-dom";
import Menu from "./components/pages/Menu";
import Navbar from "./components/layout/Navbar.jsx";
import ComingSoon from "./components/pages/ComingSoon.jsx";
import ContactUs from "./components/pages/ContactUs.jsx";
import PrivacyPolicy from "./components/sections/PrivacyPolicy.jsx";
import TermsConditions from "./components/sections/TermsConditions.jsx";
import AboutUs from "./components/pages/AboutUs.jsx";

export default function App() {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <Routes>
      <Route path="/" element={isMobile ? <MobileView /> : <HomePage />} />
      <Route path="/menu" element={<><Navbar/> <Menu/></>} />
      <Route path="/comingsoon" element={<><Navbar/> <ComingSoon/></>} /> 
      <Route path="/contact" element={<><Navbar/> <ContactUs/></>} />
      <Route path="/privacy" element={<><Navbar/> <PrivacyPolicy/></>} />
      <Route path="/terms" element={<><Navbar/> <TermsConditions/></>} />
      <Route path="/aboutus" element={<><Navbar/> <AboutUs/></>} />
    </Routes>
  );
}

